import type { RouteObject } from "react-router-dom";
import NotFound from "@/pages/NotFound";
import Home from "@/pages/home/page";
import GuidaCompleta from "@/pages/itaobuy-spreadsheet-guida-completa/page";
import ScarpeArticle from "@/pages/itaobuy-spreadsheet-scarpe/page";
import FelpeArticle from "@/pages/itaobuy-spreadsheet-felpe/page";
import TshirtArticle from "@/pages/itaobuy-spreadsheet-t-shirt/page";
import GiaccheArticle from "@/pages/itaobuy-spreadsheet-giacche/page";
import AccessoriArticle from "@/pages/itaobuy-spreadsheet-accessori/page";
import BorseArticle from "@/pages/itaobuy-spreadsheet-borse/page";
import SneakersArticle from "@/pages/itaobuy-spreadsheet-sneakers/page";
import SicurezzaArticle from "@/pages/itaobuy-spreadsheet-sicurezza/page";
import ComeUsareArticle from "@/pages/itaobuy-spreadsheet-come-usare/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/itaobuy-spreadsheet-guida-completa",
    element: <GuidaCompleta />,
  },
  {
    path: "/itaobuy-spreadsheet-scarpe",
    element: <ScarpeArticle />,
  },
  {
    path: "/itaobuy-spreadsheet-felpe",
    element: <FelpeArticle />,
  },
  {
    path: "/itaobuy-spreadsheet-t-shirt",
    element: <TshirtArticle />,
  },
  {
    path: "/itaobuy-spreadsheet-giacche",
    element: <GiaccheArticle />,
  },
  {
    path: "/itaobuy-spreadsheet-accessori",
    element: <AccessoriArticle />,
  },
  {
    path: "/itaobuy-spreadsheet-borse",
    element: <BorseArticle />,
  },
  {
    path: "/itaobuy-spreadsheet-sneakers",
    element: <SneakersArticle />,
  },
  {
    path: "/itaobuy-spreadsheet-sicurezza",
    element: <SicurezzaArticle />,
  },
  {
    path: "/itaobuy-spreadsheet-come-usare",
    element: <ComeUsareArticle />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;